import rateStay from './rateStay';

const logic = [rateStay];

export default logic;
